/* eslint-disable react-hooks/refs -- vm bundles composer refs for child panels */
import { Box } from '@mui/material'
import AiAskBarOverlays from './AiAskBarOverlays'
import AiAskBarRootPanels from './AiAskBarRootPanels'
import { buildAiAskBarRootClassName } from './buildAiAskBarRootClassName'
import { COMPOSER_ACCEPT } from './composerAccept'
import styles from './index.module.scss'

export default function AiAskBarRootView(props) {
  const {
    vm,
    actions,
    variant,
    contentWidth,
    attachmentGallerySenderLabel,
    attachmentGallerySubtitle,
    attachmentGallerySecondaryLine,
    onOpenConnections,
  } = props
  const ariaLabel = vm.isEmailReply ? 'Email reply composer' : 'AI Ask Bar'

  return (
    <Box
      component="section"
      className={buildAiAskBarRootClassName(variant, vm, contentWidth)}
      aria-label={ariaLabel}
    >
      <input
        ref={vm.fileInputRef}
        type="file"
        multiple
        accept={COMPOSER_ACCEPT}
        className={styles.hiddenFileInput}
        aria-hidden
        tabIndex={-1}
        onChange={actions.handleFileInputChange}
      />
      <AiAskBarRootPanels {...props} />
      <AiAskBarOverlays
        vm={vm}
        actions={actions}
        onOpenConnections={onOpenConnections}
        attachmentGallerySenderLabel={attachmentGallerySenderLabel}
        attachmentGallerySubtitle={attachmentGallerySubtitle}
        attachmentGallerySecondaryLine={attachmentGallerySecondaryLine}
      />
      {vm.isComposerVariant && (
        <Box className={styles.disclaimerText}>
          AI-generated content may be inaccurate or misleading. Always verify important information.
        </Box>
      )}
    </Box>
  )
}
